// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__18mk6","header":"PatientQuestionnaire_header__xx0o8","info":"PatientQuestionnaire_info__38drJ"};